import { useEffect } from 'react';
let locks = 0, original = { overflow: '', overscroll: '', scroll: 0 };
export function useScrollLock() {
  useEffect(() => {
    if (locks++ === 0) { original = { overflow: document.documentElement.style.overflow, overscroll: document.documentElement.style.overscrollBehaviorY, scroll: window.scrollY }; document.documentElement.style.overflow = 'hidden'; document.documentElement.style.overscrollBehaviorY = 'none'; }
    return () => { if (--locks === 0) { document.documentElement.style.overflow = original.overflow; document.documentElement.style.overscrollBehaviorY = original.overscroll; window.scrollTo({top:original.scroll,behavior:'instant'}); } };
  },[]);
}
